var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isSignedIn && (_vm.loadPendingOrdersStatus.pending || _vm.pendingOrders.length) ? _c('menu-scroll-lock', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "text": _vm.text,
            "disabled": _vm.disabled,
            "color": _vm.color,
            "loading": _vm.loading || _vm.loadPendingOrdersStatus.pending
          }
        }, 'v-btn', attrs, false), on), [_vm._t("default", function () {
          return [_vm._v("Add to card")];
        }), _c('v-icon', {
          staticClass: "menu-down mr-n1",
          domProps: {
            "innerHTML": _vm._s(_vm.mdiMenuDown)
          }
        })], 2)];
      }
    }], null, true),
    model: {
      value: _vm.show,
      callback: function ($$v) {
        _vm.show = $$v;
      },
      expression: "show"
    }
  }, [_c('v-list', {
    staticClass: "py-0 grey lighten-5 overflow-auto"
  }, [_c('div', {
    staticClass: "text--label-active pa-2"
  }, [_vm._v("Create new project")]), _c('cart-list-item', {
    staticClass: "pl-0",
    attrs: {
      "order-id": "new",
      "order": _vm.preview
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('select', 'new', null);
      }
    }
  }, [_c('div', {
    staticClass: "ec-dark-blue--text font-weight-bold text-body-2"
  }, [_vm._v("Create new project")])]), _c('div', {
    staticClass: "text--label-active pa-2"
  }, [_vm._v("Add to saved project")]), _vm._l(_vm.pendingOrders, function (_ref2) {
    var orderId = _ref2[0],
      order = _ref2[1];
    return _c('cart-list-item', {
      key: orderId,
      staticClass: "pl-0",
      attrs: {
        "order-id": orderId,
        "order": order
      },
      on: {
        "click": function ($event) {
          return _vm.$emit('select', orderId, order);
        }
      }
    });
  })], 2)], 1) : _c('v-btn', {
    attrs: {
      "text": _vm.text,
      "disabled": _vm.disabled,
      "color": _vm.color,
      "loading": _vm.loading
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('select', 'new', null);
      }
    }
  }, [_vm._t("default", function () {
    return [_vm._v("Add to card")];
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }